import script from "./Audio.vue?vue&type=script&lang=ts&setup=true"
export * from "./Audio.vue?vue&type=script&lang=ts&setup=true"

import "./Audio.vue?vue&type=style&index=0&id=36a281f6&lang=less"

const __exports__ = script;

export default __exports__